<app-topbar></app-topbar>

<app-sidebar>

</app-sidebar>
<ng-container>
    <div class="main-content">
        <a routerLink="/storage/items" class="btn btn-primary">Storage Items</a>
    </div>

</ng-container>
